var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.data.free == true ? "plan-card-free" : "plan-card",
      style: {
        "border-color": _vm.data.border,
        border: "solid 1px " + _vm.data.border,
        "border-radius": "5px"
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.free == true,
              expression: "data.free == true"
            }
          ],
          staticClass: "plan-card-corner"
        },
        [_c("span", { staticClass: "text" }, [_vm._v("FREE")])]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.recommended == true,
              expression: "data.recommended == true"
            }
          ],
          staticClass: "plan-card-topright"
        },
        [_vm._v("Recommended")]
      ),
      _c("div", { staticClass: "plan-card-pricing" }, [
        _vm._v(" ₹ : " + _vm._s(_vm.data.pricing) + " "),
        _vm.data.pricing > 0
          ? _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("/ year")
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "plan-card-name" }, [
        _vm._v(_vm._s(_vm.data.name))
      ]),
      _c("div", { staticClass: "plan-card-name-subtext" }, [
        _vm._v("Features you get")
      ]),
      _c(
        "ul",
        { staticClass: "plan-card-features" },
        _vm._l(_vm.data.features, function(feature, index) {
          return _c(
            "li",
            {
              key: _vm.data.id + "feature" + index,
              staticClass: "plan-card-feature"
            },
            [_vm._v(_vm._s(feature))]
          )
        }),
        0
      ),
      _vm.data.active
        ? _c(
            "v-btn",
            {
              staticClass: "plan-card-active",
              attrs: { "x-large": "", text: "", color: "#68d391" }
            },
            [
              _vm._v(" ACTIVE "),
              _c(
                "v-icon",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { color: "#68d391" }
                },
                [_vm._v("mdi-check-circle-outline")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.purchasable && !_vm.data.active,
              expression: "data.purchasable && !data.active"
            }
          ],
          staticClass: "plan-card-cta",
          attrs: { id: "submit" },
          on: {
            click: function($event) {
              return _vm.buy(_vm.data)
            }
          }
        },
        [_vm._v("BUY")]
      ),
      _c(
        "v-btn",
        {
          staticClass: "plan-card-learn",
          attrs: { text: "" },
          on: {
            click: function($event) {
              return _vm.learn(_vm.data)
            }
          }
        },
        [_vm._v("Learn More")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }